<ng-container *ngFor="let section of sections$ | ngrxPush" [ngSwitch]="section.type">
    <h2 *ngSwitchCase="RpaDescriptionSectionType.HeaderBelow">
        <dtm-ui-icon name="arrow-down-2" />
        <span>{{ section.content }}</span>
    </h2>
    <h2 *ngSwitchCase="RpaDescriptionSectionType.HeaderAbove">
        <dtm-ui-icon name="arrow-up-2" />
        <span>{{ section.content }}</span>
    </h2>
    <div *ngSwitchCase="RpaDescriptionSectionType.Text" class="text" [innerHTML]="section.content | linkify | safeHtml"></div>
    <dtm-ui-label-value *ngSwitchCase="RpaDescriptionSectionType.Contact" [label]="'dtmMapCesium.rpaDescription.contactLabel' | transloco">
        <span [innerHTML]="section.content | linkify | safeHtml"></span>
    </dtm-ui-label-value>
</ng-container>
